import styleInject from '../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z=".banner-icon-box{max-height:var(--swan-sem-space-6);max-width:var(--swan-sem-space-6)}";styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=styles.scss.js.map
